import { AirQualityProvider } from './airQualityProvider';
import { AlertsProvider } from './alertsProvider';
import { AlmanacProvider } from './almanacProvider';
import { CurrentStationObsProvider } from './currentStationsObsProvider';
import { HistoricalObsProvider } from './historicalObsProvider';
import { AverageObsProvider } from './averageObsProvider';
import { FireProvider } from './fireProvider';
import { ForecastProvider } from './forecastProvider';
import { ForecastProviderV5 } from './forecastProviderV5';
import { HurricaneProvider } from './hurricaneProvider';
import { LocationDetailsProvider } from './locationDetailsProvider';
import { MapProvider } from './mapProvider';
import { NowContentProvider } from './nowContentProvider';
import { PollenProvider } from './pollenProvider';
import { PrecipitationProvider } from './precipitationProvider';
import { StoredLocationProvider } from './storedLocationProvider';
import { StoriesProvider } from './storiesProvider';
import { UvProvider } from './uvProvider';
import { VideoProvider } from './videoProvider';
import { BackgroundImageProvider } from './backgroundImageProvider';
import { ClientLoggingProvider } from './clientLoggingProvider';
import { EntityManagementSettingProvider } from './entityManagementSettingProvider';
import { EntityManagementProvider } from './entityManagementProvider';
import { IconProvider } from './iconProvider';
import { LocationSearchProvider } from './locationSearchProvider';
import { LightningProvider } from './lightningProvider';
import { ContentManagementProvider } from './contentManagementProvider';
import { AdTargetingParameterProvider } from './adTargetingParameterProvider';
import { WeatherCamProvider } from './weatherCamProvider';
import { LoggingProvider } from './loggingProvider';
import { WeekdayWeekendProvider } from './weekdayWeekendProvider';
import { ArityProvider } from './arityProvider';
import { MapFeatureDetailsProvider } from './mapFeatureDetailsProvider';
import { ComplianceInfoProvider } from './complianceInfoProvider';
import { HourlyForecastProvider } from './hourlyForecastProvider';
import { RoadForecastProvider } from './roadForecastProvider';
import { NowConditionsProvider } from './nowConditionsProvider';
import { HourlyForecastProviderV5 } from './hourlyForecastProviderV5';
import { HourlyForecastProviderV6 } from './hourlyForecastProviderV6';
import { outdoorSportsProvider } from './outdoorSportsProvider';
import { SelectedStationObservationsProvider } from './WeatherStationObservations/SelectedStation/selectedStationObservationsProvider';
import { allStationObservationProvider } from './WeatherStationObservations/StationsList/allStationsObservationProvider';
import { HurricaneOutlookBulletinProvider } from './Hurricane/Outlook/hurricaneOutlookBulletinProvider';
import { HurricaneOutlookSummaryProvider } from './Hurricane/Outlook/hurricaneOutlookSummaryProvider';

export {
    AirQualityProvider
    , AlertsProvider
    , AlmanacProvider
    , CurrentStationObsProvider
    , AverageObsProvider
    , HistoricalObsProvider
    , FireProvider
    , ForecastProvider
    , ForecastProviderV5
    , HurricaneProvider
    , LocationDetailsProvider
    , MapProvider
    , NowContentProvider
    , PollenProvider
    , StoredLocationProvider
    , StoriesProvider
    , UvProvider
    , VideoProvider
    , BackgroundImageProvider
    , EntityManagementProvider
    , LocationSearchProvider
    , ClientLoggingProvider
    , EntityManagementSettingProvider
    , IconProvider
    , LightningProvider
    , ContentManagementProvider
    , AdTargetingParameterProvider
    , WeatherCamProvider
    , LoggingProvider
    , PrecipitationProvider
    , WeekdayWeekendProvider
    , ArityProvider
    , MapFeatureDetailsProvider
    , ComplianceInfoProvider
    , HourlyForecastProvider
    , RoadForecastProvider
    , NowConditionsProvider
    , HourlyForecastProviderV5
    , HourlyForecastProviderV6
    , outdoorSportsProvider
    , SelectedStationObservationsProvider
    , allStationObservationProvider
    , HurricaneOutlookBulletinProvider
    , HurricaneOutlookSummaryProvider
};
